export enum Position {
	JEFE = "nura_jefe",
	SUPER = "nura_super",
	COORD = "nura_coord",
}

export const POSITIONS_AVAILABLE: string[] = ["nura_jefe", "nura_super", "nura_coord"];

export const HOSPITALS_AVAILABLE: string[] = [
	"nura_sur",
	"nura_cumbres",
	"nura_conchita",
	"nura_saltillo",
	"nura_parque",
	"nura_betania",
	"nura_upaep",
	"nura_hfm",
	"nura_altagracia",
	"nura_reynosa",
	"nura_vidriera",
	"nura_sn",
	"nura_sp",
	"nura_ae",
];

export const HOSPITALS_MAP: { [key: string]: string } = {
	nura_sur: "Sur",
	nura_cumbres: "Cumbres",
	nura_conchita: "Conchita",
	nura_saltillo: "Saltillo",
	nura_parque: "Del Parque",
	nura_betania: "Betania",
	nura_upaep: "UPAEP",
	nura_hfm: "HFM",
	nura_altagracia: "Altagracia",
	nura_reynosa: "Reynosa",
	nura_vidriera: "Vidriera",
	nura_sn: "San Nicolás",
	nura_sp: "San Pedro",
	nura_ae: "Alta Especialidad",
};

export const FLOORS_MAP: { [key: string]: string } = {
	nurap_pisouno: "PISO 1",
	nurap_pisodos: "PISO 2",
	nurap_pisotres: "PISO 3",
	nurap_pisocuatro: "PISO 4",
	nurap_pisocinco: "PISO 5",
	nurap_pisoseis: "PISO 6",
	nurap_intensivos_adulto: "CUIDADOS INTENSIVOS ADULTO",
	nurap_intensivos_pediatria: "CUIDADOS INTENSIVOS PEDIATRIA",
	nurap_intermedios: "CUIDADOS INTERMEDIOS",
	nurap_obstetricia: "OBSTETRICIA",
	nurap_soporte: "SOPORTE",
};
